//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {getStableHash} from 'common';
import DataTable from 'components/table/DataTable';
import {IDataTableColumnDef} from 'types/global';
import {IProcessInfo} from 'types/process';

// Stable row id derived from process identity — must match ProcessPage.
const getHashKey = (item: any) => getStableHash(`${item.pid || ''}_${item.command || ''}`);

//---------------------------------------------------------
// Functional Component
//---------------------------------------------------------
export default function ProcessTable(props: {data: IProcessInfo; selected_rows: number[]; onChangeSelectedRows: any; onRefresh?: any; error?: boolean}) {
	const {data, selected_rows, onChangeSelectedRows, onRefresh, error} = props;

	const cols: IDataTableColumnDef[] = [
		{data_key: 'pid', header: 'PID', type: 'mono', tooltip: 'Process ID', width: 'medium'},
		{data_key: 'user', header: 'User', width: 'wide'},
		{data_key: 'command', header: 'Command', width: 'wide', type: 'mono', tooltip: 'Process name'},
		{data_key: 'status', header: 'Status', type: 'status'},
		{data_key: 'CPUUsage', header: 'CPU (%)', align: 'right', width: 'medium', type: 'mono', tooltip: 'CPU Utilization(%)'},
		{data_key: 'MemoryUsage', header: 'Memory (%)', align: 'right', width: 'medium', type: 'mono', tooltip: 'Memory Utilization(%)'},
		{data_key: 'time', header: 'Runtime', align: 'right', width: 'wide', type: 'mono'},
	];

	const rows = data.processAttr.map(item => {
		return {
			id: getHashKey(item),
			status: item.status,
			pid: item.pid,
			user: item.user,
			command: item.command,
			CPUUsage: item.CPUUsage,
			MemoryUsage: item.MemoryUsage,
			time: item.time,
		};
	});

	return <DataTable name={'Process'} columns={cols} rows={rows} selected_rows={selected_rows} onChangeSelectedRows={onChangeSelectedRows} onRefresh={onRefresh} error={error} />;
}
